module.exports = __webpack_public_path__ + "static/img/150-395-V1.90ee8bb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader/150 395/150-395-V1.gif
// module id = Ab3U
// module chunks = 0